import React from 'react';
var Danger = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "44", height: "44", viewBox: "0 0 44 44", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M22 16.5V25.6667", stroke: "var(--icon-primary-dark)", "stroke-width": "2.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M10.8903 39.2517C4.52862 39.2517 1.87028 34.705 4.95028 29.15L10.6703 18.8467L16.0603 9.16668C19.3236 3.28168 24.6769 3.28168 27.9403 9.16668L33.3303 18.865L39.0503 29.1683C42.1303 34.7233 39.4536 39.27 33.1103 39.27H22.0021V39.2517H10.8903Z", stroke: "var(--icon-primary-dark)", "stroke-width": "2.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        React.createElement("path", { d: "M21.9902 31.167H22.0067", stroke: "var(--icon-primary-dark)", "stroke-width": "2.5", "stroke-linecap": "round", "stroke-linejoin": "round" })));
};
Danger.defaultProps = {
    className: '',
};
export default Danger;
